if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        this.syncCustomFabricProperty();
        const formData = new FormData(this.form);
        const customFabricSampleVariantId = this.getCustomFabricSampleVariantId();
        /* REENABLE_CUSTOMIZATION_ADDON
        const customizationAddonLineItem = this.getCustomizationAddonLineItem(formData);
        */
        const customizationAddonLineItem = null;
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // SPRESSO
        try {
          await window.Spresso.handleAddToCart({ formData });
        } catch (ignored) {}
        if (customFabricSampleVariantId || customizationAddonLineItem) {
          config.body = JSON.stringify(
            this.getBundledLineItemPayload(formData, {
              customFabricSampleVariantId,
              customizationAddonLineItem,
            })
          );
        } else {
          delete config.headers['Content-Type'];
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      syncCustomFabricProperty() {
        if (this.dataset.customFabricEnabled !== 'true') return;

        const propertyName = 'properties[Selected Fabric]';
        const existingInput = this.form.querySelector(`input[name="${propertyName}"]`);
        let value = existingInput?.value?.trim() || '';

        // Fallback to the UI text if the hidden input was not retained.
        if (!value) {
          const selectedTextNode =
            document.querySelector('[data-custom-fabric-selected]') ||
            document.querySelector('.selected-custom-fabric') ||
            document.querySelector('.custom-fabric-selected');
          const selectedText = selectedTextNode?.textContent?.trim() || '';
          const prefix = 'Selected Fabric:';

          if (selectedText.startsWith(prefix)) {
            value = selectedText.slice(prefix.length).trim();
          }
        }

        if (!value) {
          if (existingInput) existingInput.remove();
          return;
        }

        if (existingInput) {
          existingInput.value = value;
          return;
        }

        const propertyInput = document.createElement('input');
        propertyInput.type = 'hidden';
        propertyInput.name = propertyName;
        propertyInput.value = value;
        this.form.appendChild(propertyInput);
      }

      getCustomFabricSampleVariantId() {
        const shouldOrderSample = this.form.dataset.customFabricOrderSample === 'true';
        if (!shouldOrderSample) return null;
        const customFabricValue = this.form.querySelector('input[name="properties[Selected Fabric]"]')?.value?.trim();
        if (!customFabricValue) return null;

        const rawVariantId = this.form.dataset.customFabricSampleVariantId || '';
        const parsedVariantId = Number(rawVariantId);

        if (!Number.isFinite(parsedVariantId) || parsedVariantId <= 0) return null;
        return parsedVariantId;
      }

      getLineItemProperties(formData) {
        const properties = {};

        for (const [key, value] of formData.entries()) {
          const match = /^properties\[(.+)\]$/.exec(key);
          if (!match) continue;

          const propertyKey = (match[1] || '').trim();
          const propertyValue = typeof value === 'string' ? value.trim() : '';

          if (!propertyKey || !propertyValue) continue;
          properties[propertyKey] = propertyValue;
        }

        return properties;
      }

      /* REENABLE_CUSTOMIZATION_ADDON
      getCustomizationAddonLineItem(formData) {
        const customFabricValue = formData.get('properties[Selected Fabric]')?.toString().trim() || '';
        if (!customFabricValue) return null;

        const drawer = document.getElementById('CustomFabricDrawer');
        const rawVariantId =
          this.form.dataset.customizationAddonVariantId ||
          drawer?.getAttribute('data-customization-addon-variant-id') ||
          '';
        const parsedVariantId = Number(rawVariantId);
        if (!Number.isFinite(parsedVariantId) || parsedVariantId <= 0) return null;

        const quantityValue = Number(formData.get('quantity'));
        const quantity = Number.isFinite(quantityValue) && quantityValue > 0 ? quantityValue : 1;
        const addonForProductName = (
          this.form.dataset.addonForProductName ||
          drawer?.getAttribute('data-addon-for-product-name') ||
          ''
        ).trim();
        const properties = {
          'Selected Fabric': customFabricValue,
        };

        if (addonForProductName) {
          properties['Addon For'] = addonForProductName;
        }

        return {
          id: parsedVariantId,
          quantity,
          properties,
        };
      }
      */

      getBundledLineItemPayload(formData, options = {}) {
        const { customFabricSampleVariantId = null, customizationAddonLineItem = null } = options;
        const mainVariantId = Number(formData.get('id'));
        const quantityValue = Number(formData.get('quantity'));
        const quantity = Number.isFinite(quantityValue) && quantityValue > 0 ? quantityValue : 1;
        const properties = this.getLineItemProperties(formData);
        const items = [
          {
            id: mainVariantId,
            quantity,
            properties,
          },
        ];

        if (customFabricSampleVariantId) {
          items.push({
            id: customFabricSampleVariantId,
            quantity: 1,
            properties,
          });
        }

        if (customizationAddonLineItem) {
          items.push(customizationAddonLineItem);
        }
        const payload = { items };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        return payload;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
